/* eslint-disable react/jsx-wrap-multilines */
import React, { useContext, useState } from "react";
import { withRouter } from "react-router-dom";
import { PDFDownloadLink } from "@react-pdf/renderer";

import AppContext from "../AppContext";
import {
  HugeTitle,
  CenteredWidthAndHeightLayout,
  Paragraph,
  FlexBox,
  WhiteSquareButton,
  SpacingBox,
  WhiteSquareButtonContent,
} from "../Components";
import { getTranslateByScope } from "../i18n";
import { routes } from "../routes";
import { copyOrder } from "../actions/orders";
import { getCurrentOrderId, getCurrentOrder } from "../selectors";
import { OrderConfirmationPDF } from "./OrderConfirmationPDF";
import { buildOrderPDF } from "./OrderConfirmationPDF/utils/buildOrderPDF";
import { ColourBookButton } from "./ColourBookButton";

const translate = getTranslateByScope("app.orderConfirmation");

const OrderConfirmation = withRouter(({ history }) => {
  const [orderData, setOrderData] = useState();
  const context = useContext(AppContext);
  let order = getCurrentOrder(context);
  if (order !== undefined) {
    order = order.doc;
  }

  const handleBuildOrder = () => {
    setOrderData(buildOrderPDF(context, order));
  };

  const showColourbookButton = true;

  return (
    <CenteredWidthAndHeightLayout>
      <FlexBox flexDirection="column" alignItems="center">
        <HugeTitle>{translate("title")}</HugeTitle>
        <SpacingBox marginTop="md" marginBottom="lg">
          <Paragraph>{translate("paragraph")}</Paragraph>
        </SpacingBox>

        <FlexBox
          marginTop="xl"
          justifyContent="space-between"
          flexWrap="wrap"
          style={{ maxWidth: 420 }}
        >
          <SpacingBox marginBottom="md">
            <WhiteSquareButton
              onClick={() => history.push(routes.orderCustomerSelection)}
              text={translate("newOrder")}
            />
          </SpacingBox>
          <SpacingBox marginBottom="md">
            <WhiteSquareButton
              onClick={() => {
                copyOrder({ id: getCurrentOrderId(context), context });
                history.push(routes.orderList);
              }}
              text={translate("copyOrder")}
            />
          </SpacingBox>
          <SpacingBox marginBottom="md">
            <WhiteSquareButton
              onClick={() => history.push(routes.currentOrder)}
              text={translate("seeOrder")}
            />
          </SpacingBox>

          <SpacingBox marginBottom="md">
            <WhiteSquareButton
              onClick={() => history.push(routes.orderList)}
              text={translate("yourOrders")}
            />
          </SpacingBox>

          {showColourbookButton && (
            <WhiteSquareButtonContent>
              <ColourBookButton
                status={order.status}
                id={order.id}
                currency={order.currency}
                context={context}
              />
            </WhiteSquareButtonContent>
          )}

          <SpacingBox marginBottom="md">
            {orderData ? (
              <PDFDownloadLink
                document={<OrderConfirmationPDF order={orderData} />}
                fileName="bestellbestatigung.pdf"
              >
                {({ loading }) => {
                  if (loading) {
                    return <div>Loading document...</div>;
                  }
                  return (
                    <SpacingBox marginBottom="md">
                      <WhiteSquareButton
                        text={translate("orderConfirmation")}
                      />
                    </SpacingBox>
                  );
                }}
              </PDFDownloadLink>
            ) : (
              <WhiteSquareButton
                onClick={handleBuildOrder}
                text={translate("generatePdf")}
              />
            )}
          </SpacingBox>
        </FlexBox>
      </FlexBox>
    </CenteredWidthAndHeightLayout>
  );
});

export default OrderConfirmation;
